import { JSX } from "react";
import { Button } from "../../../common/components/Button";

interface Props {
    color: string;
    title: string;
    onClick: () => void;
    imgSrc: string;
}

export const ChoiceSelectionCard = (props: Props): JSX.Element => {
    const { color, title, onClick, imgSrc } = props;

    return (
        <div
            className={"c-choice-selection-card"}
            style={{ backgroundColor: color }}
            onClick={onClick}
        >
            <p>SPRSO</p>
            <h2>{title}</h2>
            <Button variant={"primary"} type={"button"}>
                Vote
            </Button>
            <img src={imgSrc} alt={"sprso"} />
        </div>
    );
};
